import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['food', 'time', 'customTimeSelector']
  static classes = ['hidden']

  connect() {
    this.element.classList.remove(this.hiddenClass)
  }

  timeChanged() {
    this.customTimeSelectorTarget.checked = true
  }
}
